import axios from 'axios';

export const noteService = {
    getGlobalNotesService: (id, onModel, data) => axios.get(`/note/${id}/${onModel}`, { auth: true, params: { ...data } }),

    getClientNotesService: (payload) => axios.get(`/client/${payload?.clientId}/notes`, { auth: true, params: payload?.params }),

    getNoteByIdService: (id) => axios.get(`/note/${id}`, { auth: true }),

    createGlobalNoteService: (body) => axios.post(`/note`, body, { auth: true }),

    editGlobalNoteService: (id, body) => axios.patch(`/note/${id}`, body, { auth: true }),

    deleteGlobalNoteService: (id) => axios.delete(`/note/${id}`, { auth: true }),

    viewNoteService: (body) => axios.post(`/note/view`, body, { auth: true }),
};
